import config from 'services/table/const';
import TableAccess from './table.access';
import Action from './table.action';

let table = { ...config };

table.url = '/platform/usergroup';
table.columns = {
  name: {
    title: 'Nama Usergroup',
    sortable: true,
    component: (row) => {
      return <div className="text-ellipsis">{row?.name}</div>;
    },
  },
  privileges: {
    title: 'Hak Akses',
    sortable: true,
    component: (row) => {
      return <TableAccess data={row} />;
    },
  },
  action: {
    title: '',
    width: 50,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};

export default table;
